export function isBot() {
  return navigator.userAgent.toLowerCase().indexOf('bot') !== -1 || navigator.userAgent.toLowerCase().indexOf('crawler') !== -1 || navigator.userAgent.toLowerCase().indexOf('facebookexternalhit') !== -1;
}
